(() => {
  const origTitle = document.title;
  const delay = theme.settings.blurMessageDelay * 1000;
  const origDelay = theme.settings.blurMessageOrigDelay * 1000;
  let messageCounter = 0;
  let timer;

  const nextBlurMessage = () => {
    const message = messageCounter == 1 ? theme.settings.blurMessage1 : (
      messageCounter == 2 ? theme.settings.blurMessage2 : origTitle
    );
    if (message) document.title = message;
    messageCounter = (messageCounter == 1 && theme.settings.blurMessage2) ? 2 : (
      messageCounter != 0 ? 0 : 1
    );
      timer = setTimeout(() => {
      nextBlurMessage();
    }, (messageCounter == 1 ? origDelay : delay));
  };

  window.addEventListener('blur', () => {
    timer = setTimeout(() => {
      nextBlurMessage();
    }, delay);
  });

  window.addEventListener('focus', () => {
    clearTimeout(timer);
    document.title = origTitle;
    messageCounter = 0;
  });
})();
